import type { PosCartItem } from '../domain/models/PosCartItem';
import type { ListingDesignItem } from '@/features/plp/domain/models/ProductListing';

/**
 * Utility method to check if the current product detail is in the user's POS cart picks.
 */
export function isCurrentProductInPosCart(
  productDetail: { designId: number } | null,
  posCartItems: PosCartItem[]
): boolean {
  if (!productDetail) return false;
  return posCartItems.some(
    (item) => item.designId === productDetail.designId && item.sourceType === 'POS_CART'
  );
}

export function getPosCartCount(items: PosCartItem[]): number {
  return items.filter((item) => item.sourceType === 'POS_CART').length;
}

export function mapPosCartItemToListingDesignItem(item: PosCartItem): ListingDesignItem {
  const carouselSeq = item.mediaItems?.carouselSeq ?? [];
  const videoCarouselItem = carouselSeq.find((seqItem) => seqItem.type === 'video');
  const videoUrl = videoCarouselItem?.urlMap?.video_url;

  const videoIndex = carouselSeq.findIndex((seqItem) => seqItem.type === 'video');
  let hoverImageSource: { urlMap: Record<string, string> } | undefined;
  if (videoIndex >= 0) {
    hoverImageSource = carouselSeq.slice(videoIndex + 1).find((seqItem) => seqItem.type === 'image');
  } else {
    const imageItems = carouselSeq.filter((seqItem) => seqItem.type === 'image');
    hoverImageSource = imageItems[1];
  }
  const hoverImageUrl = hoverImageSource?.urlMap?.['828']
    ?? Object.values(hoverImageSource?.urlMap ?? {}).find((v) => typeof v === 'string' && v.startsWith('http'));

  return {
    designId: item.designId,
    designName: item.designName,
    imageUrl: item.imageUrl,
    productPageUrl: item.productPageUrl,
    price: item.price,
    discountedPrice: item.discountedPrice,
    discountName: item.discountName,
    categoryType: item.categoryType,
    discountPercent: item.discountPercent,
    discountOnDiamondPriceValue: item.discountOnDiamondPriceValue,
    discountValue: item.discountValue,
    customizationId: item.customizationId,
    metal: item.metal,
    videoUrl,
    hoverImageUrl,
  };
}
